module.exports = __webpack_public_path__ + "img/advantage.65b2b1b1.png";